<template>
  <form>
    <div class="row">
      <div class="col-lg-6">
        <div class="mt-4">
          <h5 class="font-weight-bold">
            {{$t('small_technical_grants_ev.regional_committee_comments')}}
          </h5>
          <comment-box v-model="EvaluationForm.model.comments" :comments="EvaluationForm.model.comments"></comment-box>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6">
        <div class="mt-4">
          <h5 class="font-weight-bold">
            {{$t('small_technical_grants_ev.eu_delegation_comments')}}
          </h5>
          <comment-box v-model="EvaluationForm.model.eu_delegation_comments" :comments="EvaluationForm.model.eu_delegation_comments"></comment-box>
        </div>
      </div>
    </div>

  </form>
</template>
<script>
  import {EvaluationForm} from "@/services";
  import InfoRight from './InfoRight';
  import ApplicationInfo from '../ApplicationInfo';
  import {CommentBox} from 'src/components';

  export default {
    components: {
      InfoRight,
      ApplicationInfo,
      CommentBox
    },
    data() {
      return {
        EvaluationForm
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    }
  }
</script>